import common from '../common'

export default {
    list(params) {
      return common.get('/rocheManage/bus/busStrategy/list',params);
    },
  
    add(params) {
      return common.postForm('/rocheManage/bus/busStrategy/add',params);
    },
  
    edit(params) {
      return common.putForm('/rocheManage/bus/busStrategy/edit',params);
    },
  
    delete(params) {
      return common.delete('/rocheManage/bus/busStrategy/delete',params);
    },
  
    deleteBatch(params) {
      return common.delete('/rocheManage/bus/busStrategy/deleteBatch',params);
    },

    exportXls(params) {
      return common.get('/rocheManage/bus/busStrategy/exportXls', params, {responseType: 'blob'});
    },

    importUrl4Excel(params) {
      return common.postForm('/rocheManage/bus/busStrategy/importExcel', params);
    },
  
    importValidUrl4Excel(params) {
      return common.postForm('/rocheManage/bus/busStrategy/importExcelValid', params);
    },
}


// WEBPACK FOOTER //
// ./src/api/bizmanagement/strategy.js